import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';

const PrivateRoute = props => {
  const { isLogged, component: Component, permission } = props;
  const routes = JSON.parse(localStorage.getItem('routes'));

  const getPermission = () => {
    if(routes){
      let aux = routes.filter(r => r.alias === permission)[0];
      if(aux){
        return true;
      }
    }
    return false;
  }

  return (
    <Route
      {...props}
      component={moreProps =>
        isLogged && getPermission() ? (
          <Component {...props} {...moreProps} />
        ) : (
          <Redirect to="/login" />
        )
      }
    />
  );
};

export default connect(state => ({
  isLogged: state.user.authenticate
}))(PrivateRoute);
